import React, { useState } from "react";
import plusIcon from "../../assets/plus-icon.svg";

const Commontab = ({
  approvedPatients,
  PatientTag,
  removeApprovedPatient,
  PatientTagMore,
  handleSubmit,
  openList,
  name,
  slug,
  smsBody,
  phone,
}) => {
  return (
    <>
      <div className="container mt-4 px-2">
        <div
          className="form-group"
          onClick={openList}
          style={{
            lineHeight: "25px",
          }}
        >
          <div
            className="d-flex tag-container  slug-input  align-items-center"
            style={{ minHeight: "2.5rem" }}
          >
            {approvedPatients.length > 0 ? (
              <>
                {approvedPatients.map((sp, i) => {
                  if (i < 2)
                    return (
                      <PatientTag
                        key={sp.id}
                        {...sp}
                        removeApprovedPatient={removeApprovedPatient}
                      />
                    );
                })}
              </>
            ) : (
              <>
                {smsBody ? (
                  <>
                    <span className="p-1 font-weight-bold border-right">
                      +91
                    </span>

                    <small
                      style={{ fontSize: "1rem", marginLeft: "6px" }}
                      className="text-muted"
                    >
                      Enter Phone Number
                    </small>
                  </>
                ) : (
                  <small
                    style={{ fontSize: "1rem", marginLeft: "6px" }}
                    className="text-muted"
                  >
                    Select Email(s)
                  </small>
                )}
              </>
            )}
            {approvedPatients.length > 2 ? (
              <>
                <PatientTagMore number={approvedPatients.length - 2} />
              </>
            ) : (
              <></>
            )}
            <div className="d-flex justify-content-center align-items-center plus-cont">
              {/* <i className="fa fa-plus plus-icon"></i> */}
              <img src={plusIcon} style={{ width: "2rem" }} />
            </div>
          </div>
          <small className="text-muted mt-1">
            Total Recipients: {approvedPatients.length}
          </small>
        </div>
        <div className="form-group ">
          <p className="border rounded p-2 mb-3 slug-input">
            Booking Appointment Link
          </p>

          <p className="border rounded p-2 slug-input">
            {smsBody ? (
              <>
                {name?.trim()} is now available online. Please visit the url{" "}
                <a href={slug} target="_blank">
                  {slug}
                </a>{" "}
                to consult.
              </>
            ) : (
              <div className="email-body">
                <p>Dear Sir/Madam,</p>
                <p>Hope you are doing well. This is {name}.</p>
                <p>
                  Kindly use this link to book an appointment with me <br />
                </p>
                <p>
                  <a
                    href={slug}
                    target="_blank"
                    style={{ wordBreak: "break-all" }}
                  >
                    {slug}
                  </a>
                </p>

                <br />
                <p>Warm Regards,</p>
                <p>{name}</p>
                <p>{phone}</p>
              </div>
            )}
          </p>

          <div className="form-group text-center">
            <button
              className="btn  share-button rounded-pill border-0 mt-3 mb-2 py-2 px-4"
              type="button"
              // style={{
              //   background: "#17bae0",
              // }}
              onClick={handleSubmit}
              disabled={approvedPatients.length > 0 ? false : true}
            >
              Share Link
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Commontab;
